<ui-modal
  uiModalPortal
  [isOpen]="isOpen"
  size="medium"
  [growVertically]="false"
  [disableOverlayClose]="true"
  position="center"
  (onClose)="close()"
  (isOpenChange)="isOpenChange.emit($event)"
>
  <div class="file-preview-fallback-modal">
    <div class="file-preview-fallback-modal__header">
      <h3 class="file-preview-fallback-modal__title">{{ "uploads.Preview_Not_Supported" | translate }}</h3>
    </div>
    <div class="file-preview-fallback-modal__body">
      <p class="file-preview-fallback-modal__message">
        {{ "uploads.Preview_Not_Supported_Download_Instead" | translate }}
      </p>
      <p class="file-preview-fallback-modal__filename">{{ fileName }}</p>
    </div>
    <div class="file-preview-fallback-modal__actions">
      <ui-button
        variant="primary"
        size="large"
        [fullWidth]="true"
        [disabled]="submitting"
        [label]="'uploads.Download_File' | translate"
        (clicked)="confirm()"
      ></ui-button>
      <ui-button
        variant="tertiary"
        size="large"
        [fullWidth]="true"
        [disabled]="submitting"
        [label]="'settings.Cancel' | translate"
        (clicked)="close()"
      ></ui-button>
    </div>
  </div>
</ui-modal>
